import { render, staticRenderFns } from "./ImportShipmentNo.vue?vue&type=template&id=31a52804&lang=pug"
import script from "./ImportShipmentNo.vue?vue&type=script&lang=js"
export * from "./ImportShipmentNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports